import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt, faCheck, faEllipsisV, faPencilAlt } from '@fortawesome/pro-solid-svg-icons';

import { LeadPropTypes } from 'components/project/prop_types';
import AccessOptions from '../../project/components/leads/access_options';

import {
  approveLeadVaultAccess,
  revokeLeadVaultAccess,
  blockLeadVaultAccess,
  unblockLeadVaultAccess
} from 'bundles/project/actions/index';
import { refreshLead } from 'bundles/project/actions/leads';
import { showNewTaskModal, showUpdateLeadModal, showLogTaskModal } from './store/actions/ui';
import { Dropdown } from 'react-bootstrap-5';
import { createPortal } from 'react-dom';

const MENU_ICON_CLASS_NAME = 'me-2 text-primary';

export class LeadOptions extends React.Component {
  static propTypes = {
    approveLeadVaultAccess: PropTypes.func.isRequired,
    blockLeadVaultAccess: PropTypes.func.isRequired,
    currentUser: PropTypes.object,
    features: PropTypes.shape({
      projectTasksActivities: PropTypes.bool.isRequired
    }),
    lead: LeadPropTypes,
    refreshLead: PropTypes.func.isRequired,
    revokeLeadVaultAccess: PropTypes.func.isRequired,
    showLogTaskModal: PropTypes.func.isRequired,
    showNewTaskModal: PropTypes.func.isRequired,
    showUpdateLeadModal: PropTypes.func.isRequired,
    unblockLeadVaultAccess: PropTypes.func.isRequired
  };

  render() {
    const { lead, features } = this.props;

    return (
      <Dropdown>
        <Dropdown.Toggle id={`dropdown-${lead.id}`}  variant="ghost">
          <FontAwesomeIcon className="clickable" icon={faEllipsisV} size="lg" style={{ color: 'initial' }}/>
        </Dropdown.Toggle>
        {createPortal(
          <Dropdown.Menu>
            {features.projectTasksActivities &&
              <React.Fragment>
                <Dropdown.Item
                  name="new-task"
                  onClick={() => this.props.showNewTaskModal(lead)}
                >
                  <FontAwesomeIcon className={MENU_ICON_CLASS_NAME}
                    fixedWidth icon={faCheck} size="sm"
                  /> New Task
                </Dropdown.Item>
                <Dropdown.Item
                  name="new-activity"
                  onClick={() => this.props.showLogTaskModal(lead)}
                >
                  <FontAwesomeIcon className={MENU_ICON_CLASS_NAME}
                    fixedWidth icon={faBolt} size="sm"
                  /> New Activity
                </Dropdown.Item>
              </React.Fragment>
            }
            <AccessOptions
              approveLeadVaultAccess={this.props.approveLeadVaultAccess}
              blockLeadVaultAccess={this.props.blockLeadVaultAccess}
              currentUser={this.props.currentUser}
              iconClassName={MENU_ICON_CLASS_NAME}
              lead={lead}
              refreshLead={this.props.refreshLead}
              revokeLeadVaultAccess={this.props.revokeLeadVaultAccess}
              unblockLeadVaultAccess={this.props.unblockLeadVaultAccess}
            />
            {(features.projectTasksActivities || lead.propertyVaultProfiles.length > 0) &&
              <Dropdown.Divider />}
            <Dropdown.Item
              name="edit-lead"
              onClick={() => this.props.showUpdateLeadModal(lead)}
            >
              <FontAwesomeIcon className={MENU_ICON_CLASS_NAME} fixedWidth icon={faPencilAlt} size="sm" /> Edit
            </Dropdown.Item>
          </Dropdown.Menu>
          , document.body)}
      </Dropdown>
    );
  }
}

const mapStateToProps = state => ({
  currentUser: state.currentUser,
  features: state.features
});

const actions = {
  approveLeadVaultAccess,
  blockLeadVaultAccess,
  showUpdateLeadModal,
  showNewTaskModal,
  showLogTaskModal,
  refreshLead,
  revokeLeadVaultAccess,
  unblockLeadVaultAccess
};

export default connect(mapStateToProps, actions)(LeadOptions);
